import { Box } from '@mui/material';
import { pxToRem } from '../../utils/getFontValue';
import { UIColors } from '../../constants/UIConstants';
import LoginAndGoogleSSO from './forms/LoginAndGoogleSSO';

/*
 * Legacy password / forgot-password routing is commented out below.
 * Forms remain in FirstTimeLogin.tsx and ForgotPassword.tsx.
 */

const loginPageStyle = {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  minHeight: '100%',
  padding: `${pxToRem(32)} ${pxToRem(24)}`,
  backgroundColor: UIColors.globalBG.grey,
};

function Login() {
  /*
  const currentLoginFormState = useAppSelector(
    (state: RootState) => state.login.currentFormState
  );
  const [cognitoUserObject, setCognitoUserObject] = useState();

  switch (currentLoginFormState) {
    case LoginFormStates.LOGIN:
      return (
        <LoginAndGoogleSSO setCognitoUserObject={setCognitoUserObject} />
      );
    case LoginFormStates.FIRST_TIME_LOGIN:
      return <FirstTimeLogin cognitoUserObject={cognitoUserObject} />;
    case LoginFormStates.FORGOT_PASSWORD:
      return <ForgotPassword />;
    default:
      return (
        <LoginAndGoogleSSO setCognitoUserObject={setCognitoUserObject} />
      );
  }
  */

  return (
    <Box sx={loginPageStyle}>
      <LoginAndGoogleSSO />
    </Box>
  );
}

export default Login;
